import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent implements OnChanges {
  @Input() activePage = 1;
  @Input() totalPages: number;
  @Input() pageLimit = 10;

  @Output() selectPage: EventEmitter<number> = new EventEmitter();
  @Output() next: EventEmitter<void> = new EventEmitter();
  @Output() prev: EventEmitter<void> = new EventEmitter();

  constructor(
    private changeDetectionRef: ChangeDetectorRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.totalPages?.currentValue && changes?.totalPages?.currentValue !== changes?.totalPages?.previousValue) {
      this._resetLocalState();
      this._publishChange();
    }
  }

  onNext() {
    if (this.activePage < this.totalPages) {
      this.activePage += 1;
      this.selectPage.emit(this.activePage);
      this._publishChange();
    }
  }

  onPrev() {
    if (this.activePage > 1) {
      this.activePage -= 1;
      this.selectPage.emit(this.activePage);
      this._publishChange();
    }
  }

  onSelect(pageNumber: number) {
    this.activePage = pageNumber;
    this.selectPage.emit(this.activePage);
    this._publishChange();
  }

  private _resetLocalState() {
    this.activePage = 1;
  }

  private _generatePages(size: number, from: number = 1) {
    return [...Array(size).keys()].map(x => from + x);
  }

  private _publishChange() {
    this.changeDetectionRef.detectChanges();
  }

  get hasNextPageList() {
    return this.totalPages > this.pageLimit;
  }

  get pages() {
    if (!this.hasNextPageList) {
      return this._generatePages(this.totalPages);
    }

    const midPoint = Math.floor(this.pageLimit / 2);

    if (this.activePage <= midPoint) {
      return this._generatePages(this.pageLimit, 1);
    }

    if (this.activePage + midPoint <= this.totalPages) {
      return this._generatePages(this.pageLimit, this.activePage - midPoint);
    }

    return this._generatePages(this.pageLimit, this.totalPages - this.pageLimit + 1);
  }

}
